import { authenticatedMiddleware } from '@/middleware/AuthenticatedMiddleware.js'
import WorkOrderCheckOut from '@/views/authenticated/work-orders/checkout/Index.vue'
import WorkOrderCheckOutSuccess from '@/views/authenticated/work-orders/checkout/Success.vue'
import WorkOrderCheckOutVerificationCode from '@/views/authenticated/work-orders/checkout/verification/Code.vue'
import WorkOrderCheckOutVerificationGeo from '@/views/authenticated/work-orders/checkout/verification/Geo.vue'
import WorkOrderDetail from '@/views/authenticated/work-orders/Detail.vue'
import WorkOrderEngineersAssistants from '@/views/authenticated/work-orders/engineers/Assistants.vue'
import WorkOrderEngineersIndex from '@/views/authenticated/work-orders/engineers/Index.vue'
import WorkOrderIndex from '@/views/authenticated/work-orders/Index.vue'
import WorkOrderManageEngineers from '@/views/authenticated/work-orders/ManageEngineers.vue'
import StartWorkChecksHazards from '@/views/authenticated/work-orders/start-work-checks/Hazards.vue'
import StartWorkChecksIndex from '@/views/authenticated/work-orders/start-work-checks/Index.vue'
import StartWorkChecksInduction from '@/views/authenticated/work-orders/start-work-checks/Induction.vue'
import StartWorkChecksSafeToProceed from '@/views/authenticated/work-orders/start-work-checks/SafeToProceed.vue'

export const workOrderRoutes = [
  {
    path: '/work-orders',
    beforeEnter: [authenticatedMiddleware],
    children: [
      {
        path: '',
        name: 'work-order.index',
        component: WorkOrderIndex,
      },
      {
        path: ':workOrderId(\\d+)',
        children: [
          {
            path: '',
            name: 'work-order.detail',
            component: WorkOrderDetail,
          },
          {
            path: 'manage-engineers',
            name: 'work-order.manage-engineers',
            component: WorkOrderManageEngineers,
          },
          {
            path: 'engineers',
            name: 'work-order.engineers.index',
            component: WorkOrderEngineersIndex,
          },
          {
            path: 'engineers/assistants',
            name: 'work-order.engineers.assistants',
            component: WorkOrderEngineersAssistants,
          },
          {
            path: 'checks',
            children: [
              {
                path: '',
                name: 'work-order.start-work-checks.index',
                component: StartWorkChecksIndex,
              },
              {
                path: 'induction',
                name: 'work-order.start-work-checks.induction',
                component: StartWorkChecksInduction,
              },
              {
                path: 'hazards',
                name: 'work-order.start-work-checks.hazards',
                component: StartWorkChecksHazards,
              },
              {
                path: 'safe-to-proceed',
                name: 'work-order.start-work-checks.safe-to-proceed',
                component: StartWorkChecksSafeToProceed,
              },
            ],
          },
          {
            path: 'check-out',
            children: [
              {
                path: '',
                name: 'work-order.checkout.index',
                component: WorkOrderCheckOut,
              },
              {
                path: 'verification',
                name: 'work-order.checkout.verification.geo',
                component: WorkOrderCheckOutVerificationGeo,
              },
              {
                path: 'verification/code',
                name: 'work-order.checkout.verification.code',
                component: WorkOrderCheckOutVerificationCode,
              },
              {
                path: 'success',
                name: 'work-order.checkout.success',
                component: WorkOrderCheckOutSuccess,
              },
            ],
          },
        ],
      },
    ],
  },
]
